module.exports = __webpack_public_path__ + "32bc0c3042596da0ed833f611c05123d.jpg";